import { Form, Select } from 'antd'
import styled from 'styled-components'
import { useCallback, useContext, useState } from 'react'
import { CaregiverDateRangePicker } from 'components/Patients/CaregiverDatePicker'
import { useStore } from 'store'
import PatientContext from 'contexts/PatientContext'
import { diagnosisDateRangeValidator } from 'components/PatientChart/utils/validators'
import { DiagnosisKeys } from '../types'

interface InputDiagnosisProps {
  fieldName: string | number
  label?: string
  required?: boolean
}

export type Props = InputDiagnosisProps

export function InputDiagnosis({
  fieldName,
  label = 'Diagnosis',
  required = true
}: InputDiagnosisProps): JSX.Element | null {
  const { idToPatientMapping } = useStore((store) => store.patient)
  const { patientId } = useContext(PatientContext)
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const caregiverTimezone = idToPatientMapping[patientId as string]?.caregiverTimezone

  const handleOpenChange = useCallback((open: boolean): void => {
    setIsOpen(open)
  }, [])

  return (
    <>
      <Column>
        <div>{label}</div>
        <Form.Item
          name={[fieldName, DiagnosisKeys.DIAGNOSIS]}
          rules={[
            {
              required: required,
              message: 'Please choose a valid diagnosis'
            }
          ]}
          style={{ margin: 0 }}
        >
          <Select
            showSearch
            placeholder="Type or select a diagnosis"
            notFoundContent="Type to search for diagnoses..."
            disabled
          />
        </Form.Item>
      </Column>
      <Column>
        <div>Symptom Control Rating</div>
        <Form.Item
          name={[fieldName, DiagnosisKeys.RATING]}
          rules={[
            {
              required: required,
              message: 'Please choose a valid rating'
            }
          ]}
          style={{ margin: 0 }}
        >
          <Select placeholder="Type or select a rating" options={controlRating} disabled />
        </Form.Item>
      </Column>
      <Column>
        <div>Diagnosis Date</div>
        <Form.Item
          name={[fieldName, DiagnosisKeys.DATE]}
          rules={[
            {
              validator: diagnosisDateRangeValidator
            }
          ]}
          style={{ margin: 0 }}
        >
          <CaregiverDateRangePicker
            timezone={caregiverTimezone}
            format="MM-DD-YYYY"
            style={{ width: '100%' }}
            open={isOpen}
            onOpenChange={handleOpenChange}
            disabled
          />
        </Form.Item>
      </Column>
    </>
  )
}

const controlRating = Array(5)
  .fill(0)
  .map((_, i) => ({
    label: `${i}`,
    value: `${i}`
  }))

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  width: 33%;
`
